import { defineComponent as l, computed as o, openBlock as u, createBlock as p, resolveDynamicComponent as m, normalizeStyle as f } from "vue";
import { IconSizes as r, IconSizeMap as i } from "./novoui-vuejs53.js";
import { icons as n } from "./novoui-vuejs40.js";
const v = /* @__PURE__ */ l({
  __name: "NIcon",
  props: {
    size: {
      type: [String, Number],
      default: r.normal
    },
    icon: {
      type: String,
      required: !1
    }
  },
  setup(s) {
    const e = s, t = o(() => typeof e.size == "number" ? `${e.size}px` : `${i[e.size]}px`), c = o(() => ({
      width: `${t.value}`,
      height: `${t.value}`
    })), a = o(() => !e.icon || !n[e.icon] ? (console.warn(`Seems you're using an icon id that might've been renamed: ${e.icon}. Have a look here to see our latest icons: https://nice-water-0ecbf7b03.3.azurestaticapps.net/?path=/story/foundations-icons--icons`), null) : typeof e.size == "string" ? n[e.icon][e.size] : e.size <= i[r.small] ? n[e.icon].small : n[e.icon].normal);
    return (z, y) => (u(), p(m(a.value), {
      style: f(c.value)
    }, null, 8, ["style"]));
  }
});
export {
  v as default
};
